import {useQuery} from "@tanstack/react-query";
import {createRmaCodeApi} from "../../../../api/support/RMA";

const useCreateRmaCode = () => {
    const {data} = useQuery({
        queryKey: ["createRmaCode"],
        queryFn: async () => await createRmaCodeApi(),
        // staleTime: 6000 * 10,
        select: (res) => res?.result.rmaCode,
    });
    return {data};
};

export default useCreateRmaCode;
